import React from 'react'

const PaymentList = () => {
  return (
    <div>
      
    </div>
  )
}

export default PaymentList
